import { writable } from 'svelte/store';
import { fetchWithSession } from '../util/fetchWithSession';

export function createActivitiesStore() {
  const { subscribe, set, update } = writable({
    activities: [],
    editActivityName: '',
    editActivityColor: '#93EDA3',
    editActivityId: null,
    allActivities: [],
  });

  function getAllActivities(analysisid) {
    return fetchWithSession(`/api/analysis/getActivityMapping/${analysisid}`)
      .then((res) => res.json())
      .then((data) => {
        const sortedActivities = Array.isArray(data) ? [...data].sort((a, b) => {
          if (a.activityname < b.activityname) return -1;
          if (a.activityname > b.activityname) return 1;
          return 0;
        }) : [];
        update(state => ({
          ...state,
          allActivities: sortedActivities,
        }));
        return sortedActivities;
      });
  }

  function saveActivity(editActivityName, editActivityColor, editActivityId, analysisid) {
    const endpoint = editActivityId ? '/api/analysis/editActivityMapping' : '/api/analysis/createActivityMapping';
    const body = editActivityId
      ? { activityname: editActivityName, color: editActivityColor, id: editActivityId }
      : { activityname: editActivityName, color: editActivityColor, analysisid };

    return fetchWithSession(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .then(() => getAllActivities(analysisid));
  }

  function deleteActivity(activityid, analysisid) {
    return fetchWithSession(`/api/analysis/deleteActivityMapping`, {
      method: "POST",
      body: JSON.stringify({
        id: activityid,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == "success") {
          return getAllActivities(analysisid);
        }
        return null;
      });
  }

  return {
    subscribe,
    set,
    update,
    getAllActivities,
    deleteActivity,
    saveActivity,
  };
}

export const activitiesStore = createActivitiesStore();
